import App from "./App.svelte";
const target = document.getElementById("cart-app");
const app = target
    ? new App({
        target,
    })
    : null;
export default app;
